
define('text!templates/modules/member/group/group-lists-controller.html',[],function () { return '<div class="empty-list-alert"></div>\n<div id="group-list"></div>\n';});

